import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { LOGO, TOPICS, MAKER } from "../data/content";

export const Cover = () => {
  const navigate = useNavigate();

  const go = (id) => navigate(`/collection#${id}`);
  const links = [...TOPICS, MAKER];

  return (
    <div
      data-testid="cover-page"
      className="relative flex h-[100svh] w-full flex-col overflow-hidden bg-[#141414]"
    >
      {/* Logo fills the frame */}
      <motion.div
        initial={{ opacity: 0, scale: 1.04 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
        className="relative z-10 flex flex-1 items-center justify-center px-4 pt-8"
      >
        <img
          src={LOGO}
          alt="Swede's Wood"
          data-testid="cover-logo"
          className="max-h-[58vh] w-auto max-w-[88vw] object-contain"
        />
      </motion.div>

      {/* Horizontal topic links along the bottom */}
      <nav
        data-testid="cover-links"
        className="relative z-10 flex shrink-0 flex-col items-center gap-5 px-4 pb-10 md:pb-14"
        aria-label="Browse our work"
      >
        <div
          className="flex items-center gap-4 text-swede-yellow"
          aria-hidden="true"
        >
          <span className="h-px w-12 bg-swede-tan/60 md:w-20" />
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round">
            <circle cx="12" cy="12" r="9" />
            <line x1="12" y1="1.5" x2="12" y2="22.5" />
            <line x1="1.5" y1="12" x2="22.5" y2="12" />
          </svg>
          <span className="h-px w-12 bg-swede-tan/60 md:w-20" />
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-3 md:gap-x-4">
          {links.map((t, i) => {
            const isMaker = t.id === "meet-swede";
            return (
              <div key={t.id} className="flex items-center">
                {isMaker && (
                  <img
                    src="/photos/valknut.png"
                    alt=""
                    aria-hidden="true"
                    data-testid="valknut-left"
                    className="mr-2 h-6 w-auto select-none opacity-90 md:mr-3 md:h-7"
                  />
                )}
                <button
                  data-testid={`cover-link-${t.id}`}
                  onClick={() => go(t.id)}
                  className="font-accent text-2xl tracking-wide text-swede-red transition-all duration-300 hover:text-[#ff5a4d] hover:drop-shadow-[0_0_12px_rgba(230,43,43,0.6)] md:text-3xl"
                >
                  {t.label}
                </button>
                {isMaker && (
                  <img
                    src="/photos/valknut.png"
                    alt=""
                    aria-hidden="true"
                    data-testid="valknut-right"
                    className="ml-2 h-6 w-auto select-none opacity-90 md:ml-3 md:h-7"
                  />
                )}
                {i < links.length - 1 && (
                  <span className="ml-2 select-none text-lg text-swede-tan/50 md:ml-4 md:text-xl">&#10022;</span>
                )}
              </div>
            );
          })}
        </div>
      </nav>
    </div>
  );
};

export default Cover;
